<script>
  import { Col, Row, Container, FormGroup, Input } from "sveltestrap";
  import { onMount } from 'svelte';

  let formData = {
    name: "",
    email: "",
    subject: "",
    comments: ""
  };
  let errors = {
    name: null,
    email: null,
    subject: null,
    comments: null
  };

  // Function to validate email
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Validate form data before submitting
  const validateForm = () => {
    let valid = true;
    
    // Reset error messages
    errors = { name: null, email: null, subject: null, comments: null };
    
    if (!formData.name) {
      errors.name = "Name is required";
      valid = false;
    }
    
    if (!formData.email) {
      errors.email = "Email is required";
      valid = false;
    } else if (!validateEmail(formData.email)) {
      errors.email = "Invalid email format";
      valid = false;
    }
    
    if (!formData.subject) {
      errors.subject = "Subject is required";
      valid = false;
    }
    
    if (!formData.comments) {
      errors.comments = "Message is required";
      valid = false;
    }

    return valid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validateForm()) {
      console.log("Form data is valid:", formData);
      // You can send the form data here
    } else {
      console.log("Form contains errors:", errors);
    }
  };
</script>

<!-- CONTACT FORM START-->
<section class="section common-section" id="contact">
  <Container>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <h1 class="section-title text-center">Get In Touch</h1>
        <div class="section-title-border mt-3" />
        <p class="section-subtitle text-muted text-center font-secondary pt-4">
          We thrive when coming up with innovative ideas but also understand that a smart concept should be supported with measurable results.
        </p>
      </Col>
    </Row>
    <Row>
      <Col lg="4">
        <div class="mt-4 pt-4">
          <p class="mt-4">
            <span class="h5">Office Address 1:</span><br />
            <span class="text-muted d-block mt-2">4461 Cedar Street Moro, AR 72368</span>
          </p>
          <p class="mt-4">
            <span class="h5">Office Address 2:</span><br />
            <span class="text-muted d-block mt-2">2467 Swick Hill Street <br />New Orleans, LA 70171</span>
          </p>
          <p class="mt-4">
            <span class="h5">Working Hours:</span><br />
            <span class="text-muted d-block mt-2">9:00AM To 6:00PM</span>
          </p>
        </div>
      </Col>
      <Col lg="8">
        <div class="custom-form mt-4 pt-4">
          <form on:submit={handleSubmit}>
            <Row>
              <Col lg="6">
                <FormGroup class="mt-2">
                  <Input
                    name="name"
                    id="name"
                    type="text"
                    class="form-control"
                    placeholder="Your name*"
                    bind:value={formData.name}
                  />
                  {#if errors.name}
                    <small class="text-danger">{errors.name}</small>
                  {/if}
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup class="mt-2">
                  <Input
                    name="email"
                    id="email"
                    type="email"
                    class="form-control"
                    placeholder="Your email*"
                    bind:value={formData.email}
                  />
                  {#if errors.email}
                    <small class="text-danger">{errors.email}</small>
                  {/if}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <FormGroup class="mt-2">
                  <Input
                    type="text"
                    class="form-control"
                    id="subject"
                    name="subject"
                    placeholder="Your Subject.."
                    bind:value={formData.subject}
                  />
                  {#if errors.subject}
                    <small class="text-danger">{errors.subject}</small>
                  {/if}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <FormGroup class="mt-2">
                  <Input
                    type="textarea"
                    name="comments"
                    id="comments"
                    rows="4"
                    class="form-control"
                    placeholder="Your message..."
                    bind:value={formData.comments}
                  />
                  {#if errors.comments}
                    <small class="text-danger">{errors.comments}</small>
                  {/if}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12" class="text-end">
                <Input
                  type="submit"
                  id="submit"
                  name="send"
                  class="submitBnt btn btn-primary"
                  value="Send Message"
                />
              </Col>
            </Row>
          </form>
        </div>
      </Col>
    </Row>
  </Container>
</section>
<!-- CONTACT FORM END-->
